// extracted by css-extract-rspack-plugin
var _1 = "PullFromPostmaster-m_badge-WY3h5QS7";
var _2 = "PullFromPostmaster-m_button-fSMOITFv dim-button";
export { _1 as "badge", _2 as "button" }
